import React from 'react';
import { ArrowRight, Clock, Shield, Zap } from 'lucide-react';
import { Button } from '@/components/ui/button';

const InstantEstimateSection = () => {
  return (
    <section className="py-16 bg-gradient-to-br from-[#0F172A] to-slate-800">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2
              className="text-3xl md:text-4xl font-bold text-white mb-4"
              style={{ fontFamily: 'Outfit, sans-serif' }}
            >
              Get Your HVAC Price in Minutes
            </h2>
            <p className="text-slate-300 text-lg mb-6">
              NOLA HVAC Connect now offers a fast and easy way to get an{' '}
              <a href="/instant-hvac-estimate-new-orleans" className="text-[#0EA5E9] hover:underline">
                instant HVAC estimate
              </a>{' '}
              online based on your home and system needs.
            </p>
            <p className="text-slate-400 mb-8">
              Compare options, understand your costs, and see pricing in minutes.
              No phone call required. No waiting days for a quote.
            </p>
            <a href="/instant-hvac-estimate-new-orleans">
              <Button className="bg-[#F97316] hover:bg-[#EA580C] text-white font-bold py-4 px-8 rounded-full text-lg">
                Start My Estimate
                <ArrowRight className="w-5 h-5 ml-2" />
              </Button>
            </a>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="bg-white/10 backdrop-blur-sm p-6 rounded-2xl text-center">
              <Clock className="w-8 h-8 text-[#0EA5E9] mx-auto mb-3" />
              <p className="text-white font-semibold">No Phone Call</p>
              <p className="text-slate-400 text-sm">Required</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm p-6 rounded-2xl text-center">
              <Zap className="w-8 h-8 text-[#F97316] mx-auto mb-3" />
              <p className="text-white font-semibold">Free Estimate</p>
              <p className="text-slate-400 text-sm">In Minutes</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm p-6 rounded-2xl text-center">
              <Shield className="w-8 h-8 text-[#0EA5E9] mx-auto mb-3" />
              <p className="text-white font-semibold">Trusted Local</p>
              <p className="text-slate-400 text-sm">Contractors</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InstantEstimateSection;
